import * as React from "react";
import { Stack } from "@mui/material";
import ETollReportFilter from "../filters/ETollReportFilter";
import ETollReportTable from "../tables/ETollReportTable";

function ETollReport() {

    return (
        <Stack direction={"column"} spacing={2} margin={"16px"}>
            <ETollReportFilter/>
            <ETollReportTable/>
        </Stack>
    )
}

export default ETollReport;